import axios from "axios"
import { DocumentData, UserData } from "../global_state"
import { Environment } from "./envirmoent"

type DataFetcherUsersAndDocuments = [{ [key: string]: DocumentData }]

export interface DataFetcherSearchQuery {
    readonly name: string
}

export class DataFetcher {
    static endpoint = `${Environment.environment.baseUrl}entry`
    static fetchUsers = async (token: string, startDate: number, endDate: number): Promise<DataFetcherUsersAndDocuments> => {
        const response = await axios.get(DataFetcher.endpoint, {
            headers: {
                "x-access-token": token
            },
            params: {
                "startDate": startDate,
                "endDate": endDate
            }
        })

        const documentsMap = response.data.documents
        const documents = Object.keys(documentsMap) as string[]

        documents.forEach((documentID: string) => {
            documentsMap[documentID].user = response.data.users[documentsMap[documentID].userID]
            documentsMap[documentID].schedueldSMS = Object.values(documentsMap[documentID].schedueldSMS)
        })

        return [documentsMap]
    }
}